import {
  AddAdminJobDetailPayload,
  EditAdminJobDetailPayload,
} from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { fetchAdminAllJobKey } from "../../queries/Job/useFetchAdminAllJob";
import getQueryClient from "../../queryClient";

export async function editJob(data: EditAdminJobDetailPayload) {
  const res = await ApiClient.put(`/EditJob`, data);
  return res.data;
}

export const useEditJob = mutationWrapper(editJob, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAdminAllJobKey);
  },
});
